import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout } from "./layouts";

// Route Views
import BlogOverview from "./views/BlogOverview";
import UserProfileLite from "./views/UserProfileLite";
import AddNewPost from "./views/AddNewPost";
import Errors from "./views/Errors";
import ComponentsOverview from "./views/ComponentsOverview";
import Tables from "./views/Tables";
import BlogPosts from "./views/BlogPosts";
import { LoginForm } from "./components/layout/MainSidebar/LoginForm";


export default [

  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect to="/blog-posts" />
  },
  {
    path: "/blog-overview",
    layout: DefaultLayout,
    component: BlogOverview,
    meta: {
      requiresAuth: true
  },
  },
  {
    path: "/user-profile-lite",
    layout: DefaultLayout,
    component: UserProfileLite,
    meta: {
      requiresAuth: true
  },
  },
  {
    path: "/add-new-post",
    layout: DefaultLayout,
    component: AddNewPost,
    meta: {
      requiresAuth: true
  },
  },
  {
    path: "/errors",
    layout: DefaultLayout,
    component: Errors,
    meta: {
      requiresAuth: true
  },
  },
  {
    path: "/components-overview",
    layout: DefaultLayout,
    component: ComponentsOverview,
    meta: {
      requiresAuth: true
  }
  },
  {
    path: "/tables",
    layout: DefaultLayout,
    component: Tables,
    meta: {
      requiresAuth: true
  },
  },
  {
    path: "/blog-posts",
    layout: DefaultLayout,
    component: BlogPosts,
    meta: {
        requiresAuth: true
    },
    
  }, 
  {
    path: "/login",
    layout: DefaultLayout,
    component: LoginForm,
  }
];
